import { forIn } from 'lodash';

export const buildWeakPasswordsData = (adminPasswords, userPasswords) => {
    let weakPasswords = 0;
    const addWeakPasswords = (weak = 0, medium = 0) => weak + medium;

    forIn(adminPasswords, value => { weakPasswords += addWeakPasswords(value.weak, value.medium) });
    forIn(userPasswords, value => { weakPasswords += addWeakPasswords(value.weak, value.medium) });

    return weakPasswords;
};
